import React from 'react';

const ComingSoonModal = ({ featureName = 'This feature', onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 px-4 sm:px-6">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md text-center">
        <h2 className="text-xl font-bold mb-2">Coming Soon!</h2>
        <p className="text-gray-600 mb-4">
          {featureName} is currently under development. Stay tuned for updates!
        </p>
        <button
          onClick={onClose}
          className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ComingSoonModal;
